import i18n from '@/lib/i18n/i18n';

import type { RiskObjectGroups, ROBicycleMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROBicycleMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_BICYCLE_NAME',
        getValue: (bicycle) => bicycle.name,
      },
      {
        label: 'RO_BICYCLE_BRAND',
        getValue: (bicycle) => bicycle.brand,
      },
      // {
      //   label: 'RO_BICYCLE_MODEL',
      //   getValue: (bicycle) => bicycle.model,
      // },
      {
        label: 'RO_BICYCLE_TYPE',
        getValue: (bicycle) => i18n.t(`BICYCLE_TYPE_${bicycle.bicycle_type}`),
      },
      // {
      //   label: 'RO_BICYCLE_PURCHASE_DATE',
      //   getValue: (bicycle) => toDateString(bicycle.purchase_date),
      // },
    ],
  },
  {
    title: 'RO_SECTION_VALUES',
    properties: [
      // {
      //   label: 'RO_BICYCLE_VALUE',
      //   getValue: (bicycle) => formatCurrency(bicycle.value),
      // },
      // {
      //   label: 'RO_BICYCLE_TAX_VALUE',
      //   getValue: (bicycle) => formatCurrency(bicycle.taxation_value),
      // },
      // {
      //   label: 'RO_BICYCLE_USAGE',
      //   getValue: (bicycle) => i18n.t(`BICYCLE_USAGE_${bicycle.usage}`),
      // },
      // {
      //   label: 'RO_BICYCLE_USED_BY_OTHERS',
      //   getValue: (bicycle) =>
      //     bicycle.used_by_others !== undefined && yesNo(bicycle.used_by_others),
      // },
      // {
      //   label: 'RO_BICYCLE_MAX_SPEED',
      //   getValue: (bicycle) => `${bicycle.speed_without_pedalling}km/h`,
      // },
    ],
  },
];

export default GROUPS;
